var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Chevron1"},React.createElement("path",{"id":"Vector","d":"M5.99999 12.8C5.79999 12.8 5.59999 12.7 5.49999 12.6C5.19999 12.3 5.19999 11.8 5.49999 11.5L8.89999 7.99999L5.49999 4.49999C5.19999 4.19999 5.19999 3.69999 5.49999 3.39999C5.79999 3.09999 6.29999 3.09999 6.59999 3.39999L10.6 7.39999C10.9 7.69999 10.9 8.19999 10.6 8.49999L6.59999 12.5C6.39999 12.7 6.19999 12.8 5.99999 12.8Z","fill":"#DD052B"})));
}

ChevronRight.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
